import { z } from "zod"

export const Cookies = z.enum(["appData", "JSESSIONID", "launcher-id"])
export type TCookies = z.infer<typeof Cookies>

export const CustomHeaders = z.enum(["x-app-data", "x-app-layout", "X-Cluster-Front"])
export type TCustomHeaders = z.infer<typeof CustomHeaders>
